import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getEntityById, updateEntity } from "../../api/entities/Entity";
import { UpdateEntityRequest } from "../../types/model/entity/Entity";

export const useEntity = (entityIdStr?: string) => {
  const queryClient = useQueryClient();
  const entityId = Number(entityIdStr);

  const result = useQuery({
    queryKey: ["entity", entityId],
    queryFn: () => getEntityById(entityId),
    enabled: !!entityId,
  });

  const mutation = useMutation({
    mutationFn: (values: UpdateEntityRequest) => updateEntity(entityId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["entity", entityId] });
    },
  });

  return {
    entityData: result.data,
    update: mutation.mutateAsync,
    isPending: result.isPending,
    isUpdating: mutation.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};